








































import J05ChatScreenPanel from "@/general/components/pages/parts/ThanksPointMessage/J05ChatScreenPanel.vue";
import { Prop, Vue, Component } from "vue-property-decorator";

@Component({
  components: {
    J05ChatScreenPanel
  }
})
export default class TheJ05ChatScreen extends Vue {
  @Prop({ type: Array, required: true }) chatLog!: any;
  @Prop({ type: Number, required: true }) unreadKeyNo!: number;
}
